import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'

import { Beans, MenuArrow, Chat } from '../../Icons'
import {
  BottomBarDropDown,
  BottomBarDropDownItem,
  BottomBarDropDownIconContainer,
  BottomBarName
} from '../../../styles/defaults-header'

class ServiceMenu extends Component {
  handleClick(e) {
    this.props.onClickLink(e)
  }

  handleBack() {
    this.props.onClickBack()
  }

  render() {
    return (
      <BottomBarDropDown child z="1" right>
        <BottomBarName>Klantenservice</BottomBarName>

        <BottomBarDropDownItem onClick={this.handleBack.bind(this)}>
          <BottomBarDropDownIconContainer black>
            <MenuArrow size="" />
          </BottomBarDropDownIconContainer>
          Terug
        </BottomBarDropDownItem>

        <Link to="/faq" onClick={this.handleClick.bind(this)}>
          <BottomBarDropDownItem>
            <BottomBarDropDownIconContainer>
              <Beans size="" />
            </BottomBarDropDownIconContainer>
            FAQ
          </BottomBarDropDownItem>
        </Link>

        {this.props.permissions.reportError ? (
          <Link to="/storing-melden" onClick={this.handleClick.bind(this)}>
            <BottomBarDropDownItem>
              <BottomBarDropDownIconContainer>
                <Chat size="" />
              </BottomBarDropDownIconContainer>
              Storing melden
            </BottomBarDropDownItem>
          </Link>
        ) : null}
      </BottomBarDropDown>
    )
  }
}

export default withRouter(ServiceMenu)



// WEBPACK FOOTER //
// ./src/components/MobileHeader/ServiceMenu/index.js